<div [class]="'shimmerBG ' + type() + ' h-' + height() + ' w-' + width() + '  m-b-' + marginBottom() + ' m-t-' + marginTop() " [style.height.px]="height()"></div>
